module.exports = __webpack_public_path__ + "static/media/arrow.6e5e8f68.svg";